import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"text-align":"center","margin-bottom":"2rem"}
}
const _hoisted_2 = { class: "col-sm-6" }
const _hoisted_3 = { class: "panel-body" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Organisation "),
  /*#__PURE__*/_createElementVNode("em", null, "Solo")
], -1)
const _hoisted_5 = { style: {"margin":"20px 20%"} }
const _hoisted_6 = {
  key: 0,
  class: "col-sm-6"
}
const _hoisted_7 = { class: "panel-body" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Organisation "),
  /*#__PURE__*/_createElementVNode("em", null, "Viewpoints")
], -1)
const _hoisted_9 = { style: {"margin":"20px 20%"} }

import HeadFromModel from "../../head/head-from-model.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'organisation-heads',
  props: {
    id: {},
    hasViewpoints: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_ctx.id)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(HeadFromModel, {
                kind: "orgsolo",
                "head-id": _ctx.id,
                ref: "soloHead"
              }, null, 8, ["head-id"])
            ])
          ])
        ]),
        (_ctx.hasViewpoints)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(HeadFromModel, {
                    kind: "orgviewpoints",
                    "head-id": _ctx.id,
                    ref: "viewpointsHead"
                  }, null, 8, ["head-id"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})